const store = 'learningContinuum';

export default {
    learningContinuumData: [store],
    learningContinuumLoadedForTest: function(testkey) {
        return [
            [store],
            (s) => {
                return s.has(testkey);
            },
        ];
    },
};
